var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (typeof _vm.value === 'number')?_c('span',[_vm._v(" "+_vm._s(new Intl.NumberFormat(_vm.getLocale, _vm.getOptions).format(_vm.value))+" ")]):_c('span',[_vm._v("--")])}
var staticRenderFns = []

export { render, staticRenderFns }